// 算法  Mc QED5 Speed
function QuestionnaireSum(arrData, questionnaire) {
  let num = 0;
  let bkStr = "";
  for (let i = 0; i < arrData.length; i++) {
    if (arrData[i] === undefined) {
      return;
    }
    num += Number(arrData[i]);
  }
  switch (questionnaire) {
    case "Speed":
      if (num > 0) bkStr = "txtDryEye";
      else if (num <= 0) bkStr = "txtNormal";
      break;
    case "DEQ":
      if (num <= 6) bkStr = "txtNormal";
      else if (num > 6 && num <= 12) bkStr = "txtDryEye";
      else if (num > 12) bkStr = "txtAccompanied";
      break;
    case "McMonnies":
      if (num <= 14.5) bkStr = "txtNormal";
      else if (num > 14.5) bkStr = "txtDryEye";
      break;
  }
  return { num, bkStr };
}
function QuestionnaireArr(arrData, questionnaire) {
  let count = [];
  let countArrAy = arrData;
  if (countArrAy) {
    for (let i = 0; i < countArrAy.length; i++) {
      if (countArrAy[i].val) {
        count.push(Number(countArrAy[i].val));
      }
    }
  }
  let num = 0;
  let bkStr = "";
  for (let i = 0; i < count.length; i++) {
    if (count[i] === undefined) {
      return;
    }
    num += Number(count[i]);
  }
  switch (questionnaire) {
    case "Speed":
      if (num > 0) bkStr = "txtDryEye";
      else if (num <= 0) bkStr = "txtNormal";
      break;
    case "DEQ":
      if (num <= 6) bkStr = "txtNormal";
      else if (num > 6 && num <= 12) bkStr = "txtDryEye";
      else if (num > 12) bkStr = "txtAccompanied";
      break;
    case "McMonnies":
      if (num <= 14.5) bkStr = "txtNormal";
      else if (num > 14.5) bkStr = "txtDryEye";
      break;
  }
  return { num, bkStr };
}
// DryEyeMain
function QuestionnaireDryEyeMain(arrData) {
  let num = 0;
  for (let i = 0; i < arrData.length; i++) {
    if (arrData[i] !== "up" && arrData[i] !== "down") {
      if (arrData[i]) num += Number(arrData[i]);
    }
  }
  let bkStr;
  if (num >= 7) {
    bkStr = "txtDryEye";
  } else {
    bkStr = "txtNormal";
  }

  return { num, bkStr };
}
// OSDI
function QuestionnaireOSDI(arrData) {
  let num = 0;
  let bkStr = "";
  for (let i = 0; i < arrData.length; i++) {
    if (arrData[i]) num += Number(arrData[i] === "-1" ? 0 : arrData[i]);
  }
  let Osum = (num * 25) / arrData.length;
  Osum = Osum < 0 ? 0 : Osum;

  let Osumtext;
  if (Osum) {
    Osumtext = Math.round(Math.floor(Osum * 100) / 100);
  } else {
    Osumtext = 0;
  }
  if (Osumtext >= 33) {
    bkStr = "txtSevereDryEye";
  } else if (Osumtext > 22 && Osumtext <= 32) {
    bkStr = "txtModerateDryEye";
  } else if (Osumtext >= 13 && Osumtext <= 22) {
    bkStr = "txtMildDryEye";
  } else if (Osumtext >= 0 && Osumtext < 13) {
    bkStr = "txtNormal";
  }

  return { Osumtext, bkStr };
}
export { QuestionnaireSum, QuestionnaireArr, QuestionnaireOSDI, QuestionnaireDryEyeMain };



// WEBPACK FOOTER //
// ./src/dryeye/js/questionNaire.js